import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "service_form",
    style: `background-color: #fff`
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-lg-12" };
const _hoisted_6 = { class: "form__field float-label" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { for: "name" }, "Name*", -1);
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-lg-12" };
const _hoisted_10 = { class: "form__field float-label" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { for: "email" }, "Email*", -1);
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-lg-12" };
const _hoisted_14 = { class: "form__field float-label" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", { for: "message" }, "Message", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "row mt-5 pt-5" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-lg-12 privacy-policy" }, [
        /*#__PURE__*/ _createTextVNode(" By submitting this form, I agree that Absolute may use personal data in accordance with the "),
        /*#__PURE__*/ _createElementVNode("a", {
            href: "/privacy-policy",
            class: "no-style"
        }, "privacy policy.")
    ])
], -1);
const _hoisted_17 = { class: "row" };
const _hoisted_18 = { class: "col-lg-12 mt-2" };
const _hoisted_19 = ["value", "disabled"];
const _hoisted_20 = {
    key: 0,
    class: "form__message--wrapper"
};
const _hoisted_21 = { class: "status" };
const _hoisted_22 = ["innerHTML"];
import { computed, onMounted, ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { masterForm } from '../mixins/masterForm';
const formId = 24; // Landing Page Form ID
export default /*#__PURE__*/ _defineComponent({
    __name: 'landing_page_form',
    setup(__props) {
        const landingPage = ref('Education');
        const name = ref('');
        const emailAddress = ref('');
        const message = ref('');
        const recaptchaSiteKey = window.Laravel.recaptchaSiteKey;
        const recaptchaResponse = ref('');
        const formSubmitting = ref(false);
        const formSuccess = ref(false);
        const formError = ref(false);
        const formMessage = ref('');
        // Function to inject the script
        const injectScript = (src) => {
            return new Promise((resolve, reject) => {
                if (!document.querySelector(`script[src="${src}"]`)) {
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = src;
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                }
            });
        };
        // Function to execute reCAPTCHA
        const executeRecaptcha = (recaptchaSiteKey, formId, recaptchaResponse) => {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(recaptchaSiteKey, { action: 'formcategory' + formId })
                    .then((token) => {
                    if (token) {
                        recaptchaResponse.value = token;
                        document.getElementById('recaptchaResponse' + formId)?.setAttribute('value', token);
                    }
                })
                    .catch((error) => {
                    console.error('Error executing reCAPTCHA:', error);
                });
            });
        };
        onMounted(() => {
            injectScript('https://www.google.com/recaptcha/api.js?render=' + recaptchaSiteKey)
                .then(() => {
                executeRecaptcha(recaptchaSiteKey, formId, recaptchaResponse);
            })
                .catch((error) => {
                console.error('Error loading reCAPTCHA script:', error);
            });
        });
        const textareaHeight = computed(() => {
            return message.value.trim() !== '' ? '10rem' : '';
        });
        const rules = {
            name: { required },
            emailAddress: { required, email },
            message: {}
        };
        const v$ = useVuelidate(rules, {
            name,
            emailAddress,
            message
        });
        function canSubmit() {
            if (formSubmitting.value) {
                return false;
            }
            if (v$) {
                // Check if the form is invalid
                return !v$.value.$invalid;
            }
            // If v$ doesn't exist, assume form cannot be submitted
            return false;
        }
        const handleSubmit = () => {
            if (!canSubmit()) {
                return;
            }
            formSubmitting.value = true;
            masterForm.methods.submitForm({
                category_id: formId,
                name: name.value,
                email: emailAddress.value,
                message: message.value,
                subject: 'Enquiry: ' + landingPage.value,
                landingPage: landingPage.value,
                recaptcha_response: recaptchaResponse.value
            }, handleResponse, false);
        };
        const handleResponse = (response) => {
            if (response.status === 'success') {
                formSuccess.value = true;
                // Push the event to the dataLayer for GTM
                window.dataLayer?.push({
                    'event': 'form_submit',
                    'form': 'landing_page',
                    'subject': landingPage.value,
                });
                // Form has been successfully submitted, so we can reset the form
                name.value = '';
                emailAddress.value = '';
                message.value = '';
                recaptchaResponse.value = '';
            }
            else {
                formError.value = false;
            }
            // When we show a message, we set the formSubmitting flag to false
            formSubmitting.value = false;
            formMessage.value = response.message;
        };
        // Apply mixins or do other setup logic
        const applyMixins = () => {
            // Apply masterForm mixin
            Object.assign({}, masterForm);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("form", {
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (handleSubmit()), ["prevent"]))
                    }, [
                        _createElementVNode("input", {
                            type: "hidden",
                            name: "recaptcha_response",
                            id: 'recaptchaResponse' + formId,
                            value: ""
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "name",
                                        tabindex: "1",
                                        placeholder: "Please enter your name",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(v$).name.$model) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(v$).name.$model]
                                    ]),
                                    _hoisted_7
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "email",
                                        tabindex: "3",
                                        placeholder: "Please enter your email",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(v$).emailAddress.$model) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(v$).emailAddress.$model]
                                    ]),
                                    _hoisted_11
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "message",
                                        tabindex: "6",
                                        placeholder: "How can we help?",
                                        style: _normalizeStyle({ height: textareaHeight.value }),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(v$).message.$model) = $event))
                                    }, null, 4), [
                                        [_vModelText, _unref(v$).message.$model]
                                    ]),
                                    _hoisted_15
                                ])
                            ])
                        ]),
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("input", {
                                    class: _normalizeClass(["button button--green", { 'is-submitting': formSubmitting.value }]),
                                    type: "submit",
                                    value: formSubmitting.value ? 'Submitting...' : 'Submit',
                                    disabled: !canSubmit()
                                }, null, 10, _hoisted_19)
                            ])
                        ])
                    ], 32),
                    (formSuccess.value || formError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(formSuccess.value ? 'Success' : 'Error'), 1),
                            _createElementVNode("span", {
                                class: "form__message",
                                innerHTML: formMessage.value
                            }, null, 8, _hoisted_22)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
